<template>
  <div>
    <div v-if="this.$route.path=='/report/statistics/materialAnalysis'">
      <div class="page-title" style="margin-bottom: 20px;">巨量素材分析</div>
      <el-tabs v-model="tabActiveName" @tab-click="handleClick" style="margin: 0 0 15px;">
        <el-tab-pane label=" 图片 " name="image"></el-tab-pane>
        <el-tab-pane label=" 视频 " name="video"></el-tab-pane>
        <el-tab-pane label=" 标题 " name="title"></el-tab-pane>
      </el-tabs>
      <!-- 表单查询 -->
      <el-form ref="queryFormRef" class="query-form" label-width="80px" :model="queryForm" inline>
        <div>
          <el-form-item label="日期范围">
            <el-date-picker @change="changeTime"
              v-model="timeDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="素材类型" v-if="tabActiveName !== 'title'">
            <!-- <el-select v-model="queryForm.agentAccountId" filterable clearable placeholder="请选择投放账户">
              <el-option v-for="item in accountList" :key="item.agentAccountId" :label="item.agentAccountName" :value="item.agentAccountId">
              </el-option>
            </el-select> -->
            <el-select v-model="queryForm.agentImageMode" @change="changeTime" clearable placeholder="请选择素材分类">
              <el-option
                v-for="item in materialData"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        <!-- </div> -->
        <!-- <div> -->
          <el-form-item class="fr">
            <el-button v-permission="'imgReport:applyImgCustomColumnData'"
            @click="showColDialog" icon="iconfont icon-zidingyiguanli-copy" size="medium" style="margin-right: 13px;" type="primary">
              自定义列
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 表格 -->
      <el-table class="tableBox roleTable"
        :data="allData.pageData" v-loading="tableLoading"
        border style="width: 100%">
        <el-table-column label="素材" min-width="100px" prop="reportDate" fixed>
          <template slot-scope="scope">
            <div v-if="scope.$index!=0">
              <div v-if="tabActiveName === 'image'">
                <el-popover :ref="`popoverPi-${scope.$index}`"
                placement="right" trigger="hover"
                :width="scope.row.agentUrl.length == 1 ? 260 : 440">
                  <div class="img-box" style="width:100%; height:auto;background-color:#fff;">
                    <img v-if="scope.row.agentUrl.length !== 3" :src="scope.row.agentUrl[0]" alt="">
                    <div v-else class="item-img" v-for="(item, index) in scope.row.agentUrl" :key="index">
                      <img :src="item" alt="">
                    </div>
                  </div>
                  <div class="img-box margin10" slot="reference">
                    <img v-if="scope.row.agentUrl.length !== 3" :src="scope.row.agentUrl[0]" alt="">
                    <div v-else class="item-img" v-for="(item, index) in scope.row.agentUrl" :key="index">
                      <img :src="item" alt="">
                    </div>
                  </div>
                </el-popover>
              </div>
              <div v-else-if="tabActiveName === 'video'">
                <el-popover :ref="`popoverVi-${scope.$index}`" @hide="hideVideo(scope)"
                placement="right" trigger="hover" @show="showVideo(scope)"
                :width="260">
                  <div class="img-box" style="width:100%; height:auto;background-color:#fff;">
                    <video :src="scope.row.url" style="width:100%;height:100%" :ref="`videoPlay-${scope.$index}`"
                    controls preload="auto" loop="loop" muted="muted">您的浏览器不支持视频播放</video>
                  </div>
                  <div class="img-box margin10" slot="reference">
                    <img :src="scope.row.agentUrl[0]" alt="">
                    <div class="video"><i class="iconfont icon-sanjiao"></i></div>
                  </div>
                </el-popover>
              </div>
              <div v-else class="margin10">{{scope.row.agentMaterialId}}</div>
            </div>
            <div v-else>{{scope.row.agentUrl}}</div>
          </template>
        </el-table-column>
        <el-table-column label="素材类型" min-width="88px" prop="agentImageMode">
          <template slot-scope="scope">
            <div v-if="tabActiveName !== 'title'">{{materialArr[scope.row.agentImageMode]}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="日期" min-width="100px" prop="reportDate"></el-table-column>
        <el-table-column label="素材ID" :min-width="tabActiveName !== 'title'?'170px':'88px'" prop="agentMaterialId">
          <template slot-scope="scope">
            <div v-if="tabActiveName !== 'title'">{{scope.row.agentMaterialId}}</div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="关联账户" min-width="88px" prop="accountCount">
          <template slot-scope="scope">
            <div v-if="scope.$index!=0">
              <el-popover :disabled="scope.row.accountNames.length === 0"
                placement="top"
                width="300"
                trigger="hover">
                <div class="popo-box">
                  <p v-for="(item, index) in scope.row.accountNames" :key="index">{{item}}</p>
                </div>
                <p slot="reference" class="cursor">{{scope.row.accountNames.length}}个</p>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关联计划" min-width="88px" prop="adCount">
          <template slot-scope="scope">
            <div v-if="scope.$index!=0">
              <el-popover :disabled="scope.row.adCountNames.length === 0"
                placement="top"
                width="300"
                trigger="hover">
                <div class="popo-box">
                  <p v-for="(item, index) in scope.row.adCountNames" :key="index">{{item}}</p>
                </div>
                <p slot="reference" class="cursor">{{scope.row.adCountNames.length}}个</p>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关联创意" min-width="88px" prop="creativeCount">
          <template slot-scope="scope">
            <div v-if="scope.$index!=0">
              <el-popover :disabled="scope.row.creativeCountNames.length === 0"
                placement="top"
                width="300"
                trigger="hover">
                <div class="popo-box">
                  <p v-for="(item, index) in scope.row.creativeCountNames" :key="index">{{item}}</p>
                </div>
                <p slot="reference" class="cursor">{{scope.row.creativeCountNames.length}}个</p>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="(col,index) in allData.headerData" :fixed="col.fixed"
        :prop="col.dictValue" :label="col.dictName" :key="index" min-width="88px">
        </el-table-column>
        <el-table-column v-if="allData.pageData.length !== 0" label="操作" min-width="148px" prop="reportDate" fixed="right">
          <template slot-scope="scope">
            <div v-if="scope.$index!=0">
              <el-button @click="gotoPage(scope.row, 'account')" type="text" size="small">账户详情</el-button>
              <el-button @click="gotoPage(scope.row, 'creative')" type="text" size="small">创意详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paging-box" v-if="pageTotal > 0">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="queryForm.pageNum"
          :page-sizes="[10, 20, 40, 80, 100]"
          @size-change="handleSizeChange"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
      <!-- 自定义列对话框 -->
      <set-column :colsDialogFlag.sync="colsDialogFlag" @dragEnd="dragEnd" :leftMenu="false"
      :listdata="listdata" :checkedList="checkedList"></set-column>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import setColumn from './../../components/setColumn'
// 公用
import { handleTimeNew } from '@/components/public'
export default {
  name: 'materialAnalysis',
  // 拖动排序
  components: {
    draggable,
    setColumn
  },
  data () {
    return {
      tableLoading: false,
      timeDate: [handleTimeNew(new Date()), handleTimeNew(new Date())],
      // 查询表单
      queryForm: {
        startDate: handleTimeNew(new Date()),
        endDate: handleTimeNew(new Date()),
        // agentAccountId: '', // 代理平台账户ID
        agentImageMode: '', // 素材分类
        // 分页
        pageNum: 1,
        pageSize: 10 // 每页显示的数据条数
      },
      // 分页
      pageTotal: 0,
      tabActiveName: 'image',
      apiUrl: '/api/analyse/image/list', // 接口地址
      accountList: [], // 投放账户
      materialData: [{ // 素材分类
        value: 'CREATIVE_IMAGE_MODE_LARGE',
        name: '横版大图'
      }, {
        value: 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL',
        name: '竖版大图'
      }, {
        value: 'CREATIVE_IMAGE_MODE_SMALL',
        name: '小图'
      }, {
        value: 'CREATIVE_IMAGE_MODE_UNION_SPLASH',
        name: '穿山甲开屏图片'
      }],
      materialArr: { // 素材类型展示
        'CREATIVE_IMAGE_MODE_LARGE': '横版大图',
        'CREATIVE_IMAGE_MODE_LARGE_VERTICAL': '竖版大图',
        'CREATIVE_IMAGE_MODE_SMALL': '小图',
        'CREATIVE_IMAGE_MODE_UNION_SPLASH': '穿山甲开屏图片',
        'CREATIVE_IMAGE_MODE_VIDEO': '横版视频',
        'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL': '竖版视频'
      },
      // 表格数据
      allData: {
        headerData: [],
        pageData: []
      },
      // 自定义列对话框
      colsDialogFlag: false,
      editBtn: true, // 自定义列应用按钮显示隐藏
      // 勾选上的列表
      checkedList: [],
      listdata: []
    }
  },
  created () {
    if (this.$route.path === '/report/statistics/materialAnalysis') {
      this.materialListData() // 获取查询数据
    }
  },
  watch: {
    // 监测路由
    $route (to) {
      if (this.$route.path === '/report/statistics/materialAnalysis') {
        this.materialListData() // 获取查询数据
      }
    }
  },
  methods: {
    // tab切换
    handleClick (tab, event) {
      this.queryForm.startDate = handleTimeNew(new Date())
      this.queryForm.endDate = handleTimeNew(new Date())
      this.timeDate = [handleTimeNew(new Date()), handleTimeNew(new Date())]
      this.queryForm.pageNum = 1
      this.queryForm.pageSize = 10
      // this.queryForm.agentAccountId = ''
      this.queryForm.agentImageMode = ''
      this.tabActiveName = tab.name
      if (tab.name === 'image') {
        this.apiUrl = '/api/analyse/image/list'
        this.materialData = [{
          value: 'CREATIVE_IMAGE_MODE_LARGE',
          name: '横版大图'
        }, {
          value: 'CREATIVE_IMAGE_MODE_LARGE_VERTICAL',
          name: '竖版大图'
        }, {
          value: 'CREATIVE_IMAGE_MODE_SMALL',
          name: '小图'
        }, {
          value: 'CREATIVE_IMAGE_MODE_UNION_SPLASH',
          name: '穿山甲开屏图片'
        }]
      } else if (tab.name === 'video') {
        this.apiUrl = '/api/analyse/video/list'
        this.materialData = [{
          value: 'CREATIVE_IMAGE_MODE_VIDEO',
          name: '横版视频'
        }, {
          value: 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL',
          name: '竖版视频'
        }]
      } else {
        this.apiUrl = '/api/analyse/title/list'
      }
      // 更新素材列表
      this.materialListData()
    },
    // 页面跳转
    gotoPage (row, page) {
      if (page === 'account') {
        this.$router.push({
          path: '/report/statistics/materialAnalysis/accountMaterialAnalysis',
          query: {'type': this.tabActiveName, 'id': row.agentMaterialId, 'time': row.reportDate}
        })
      } else if (page === 'creative') {
        this.$router.push({
          path: '/report/statistics/materialAnalysis/creativeDetails',
          query: {'type': this.tabActiveName, 'id': row.agentMaterialId, 'time': row.reportDate}
        })
      }
    },
    // 弹出层展示开始播放视频
    showVideo (scope) {
      this.$refs[`videoPlay-${scope.$index}`].play()
      // this.toPlay(row)
    },
    toPlay (scope) {
      this.$refs[`videoPlay-${scope.$index}`].paused === true ? this.$refs[`videoPlay-${scope.$index}`].play() : this.$refs[`videoPlay-${scope.$index}`].pause()
    },
    // 弹出层隐藏暂停播放视频
    hideVideo (scope) {
      // console.log(this.$refs[`videoPlay-${scope.$index}`].paused)
      this.$refs[`videoPlay-${scope.$index}`].pause()
    },
    // 切换分页
    handleCurrentChange (val) {
      this.materialListData()
    },
    // 切换数据显示条数
    handleSizeChange (size) {
      this.queryForm.pageSize = size
      this.materialListData()
    },
    // 获取查询数据
    materialListData () {
      if (this.timeDate) {
        this.queryForm.startDate = this.timeDate[0]
        this.queryForm.endDate = this.timeDate[1]
      } else {
        this.queryForm.startDate = ''
        this.queryForm.endDate = ''
      }
      // 开启tableLoading
      this.tableLoading = true
      this.allData.headerData = []
      this.allData.pageData = []
      this.$service.post(this.apiUrl, this.queryForm).then(res => {
        if (res.code === 200) {
          // 关闭tableLoading
          this.tableLoading = false
          this.allData.headerData = res.result.headerData || []
          this.allData.pageData = res.result.pageData || []
          this.pageTotal = res.result.total
          this.allData.pageData.forEach((item, index) => {
            if (index !== 0) {
              item.agentUrl = item.agentUrl.trim().split(',')
              item.accountNames = this.strToArr(item.accountNames)
              item.adCountNames = this.strToArr(item.adCountNames)
              item.creativeCountNames = this.strToArr(item.creativeCountNames)
            }
            item.ctr = item.ctr + '%'
            item.convertRate = item.convertRate + '%'
          })
        }
      }).catch(Err => {
        this.tableLoading = false
      })
    },
    // 字符串截取转化为数组
    strToArr (str) {
      return str.trim().substring(0, str.length - 1).split('#,')
    },
    // 选择时间获取表格数据
    changeTime () {
      this.queryForm.pageNum = 1
      this.materialListData()
    },
    /*
    * 自定义列的对话框
    */
    // 显示自定义列对话框
    showColDialog () {
      this.checkedList = [] // 清空选中的列
      this.$service.post('/api/analyse/materialCustomColumnList').then(res => {
        if (res.code === 200) {
          this.listdata = res.result.columnData
          this.checkedList = res.result.columnOrderData
          this.colsDialogFlag = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 点击确定，获取拖动排序的列表
    dragEnd () {
      console.log(JSON.stringify(this.checkedList, null, '\t'))
      let jsonData = {
        'columnDetailData': this.checkedList
      }
      this.$service.post('/api/analyse/applyMaterialCustomColumn', jsonData).then(res => {
        if (res.code === 200) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.changeTime()
        }
      })
      // 隐藏对话框
      this.colsDialogFlag = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .roleTable {
  .el-table__fixed {
    z-index: 11;
  }
  .el-table__fixed-right {
    z-index: 11;
  }
}
.margin10{
  margin: 10px 0;
}
// 图片放大
.img-box{
  width: 80px;
  height: 45px;
  border-radius: 3px;
  background-color: rgba(0,0,0,0.8);
  overflow: hidden;
  display: flex;
  position: relative;
  .item-img{
    flex: 1;
    margin-left: 2px;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
  }
  img{
    max-width: 100%;
    max-height: 100%;
    // width: 80px;
    // height: 45px;
    margin: auto;
  }
  .video{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 20px;
    height: 20px;
    line-height: 18px;
    text-align: center;
    border: 1px solid #fff;
    border-radius: 50%;
    color: #fff;
    .icon-sanjiao{
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/analyze/materialAnalysis.vue